import { FormBase } from 'core/components';

export default class PalletizeFulfillmentOrderForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouse',
					fields: [
						{
							name: 'id',
							label: 'FULFILLMENTORDER.PALLETIZINGMODE.WAREHOUSE',
							rules: 'required',
						},
					],
				},
				{
					name: 'pallet',
					fields: [
						{
							name: 'id',
							label: 'FULFILLMENTORDER.PALLETIZINGMODE.PALLET',
							rules: 'required',
						},
					],
				},
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.TRACKINGNUMBER',
				},
			],
		};
	}
	options() {
		return { validateOnBlur: false, showErrorsOnReset: false, validateOnChange: false };
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/PalletizeFulfillmentOrderForm.js